import {AxiosResponse} from 'axios';
import {
  GetPlatformOrderListDto,
  PatchPlatformOrderDto,
  PostPlatformOrderDto,
  PlatformOrderDto,
} from './dto/platformOrder';
import callApi from './index';

export const createPlatformOrder = (
  data: PostPlatformOrderDto,
): Promise<AxiosResponse<{data: PlatformOrderDto}, any>> | undefined => {
  return callApi('post', `/platform/order`, data);
};

export const createPlatformOrderPayment = (
  data: PostPlatformOrderDto,
): Promise<AxiosResponse<{data: PlatformOrderDto}, any>> => {
  return callApi('post', `/platform/order/payment`, data) as Promise<
    AxiosResponse<{data: PlatformOrderDto}, any>
  >;
};

export const getPlatformOrderList = (
  data: GetPlatformOrderListDto,
): Promise<AxiosResponse<{items: PlatformOrderDto[]}, any>> | undefined => {
  const options = {orderBy: 'createdAt', sort: 'DESC', ...data};
  return callApi('get', `/platform/order/list`, options);
};

export const updatePlatformOrder = (
  id: string,
  data: PatchPlatformOrderDto,
) => {
  return callApi('patch', `/platform/order/${id}`, data);
};

export const deletePlatformOrder = (id: string) => {
  return callApi('delete', `/platform/order/${id}`);
};

export const deleteManyPlatformOrder = (ids: string[]) => {
  return callApi('delete', `/platform/order/bulk`, {ids});
};
